<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :filter-columns="filterColumns"
    :form="form"
    ref="sourcePage"
    :title="$t('model.user')"
    :form-columns="formColumns"
    :actions="actions"
    resource="users"
    index-exec-filter-router-type="push"
    :onFetchData="onFetchData"
  />
</template>

<script>
import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import {
  filterColumnsExtend,
  columnsExtend,
  formColumnsExtend,
} from '../admin_grapes/users.js';
import { TOKEN_STORAGE_KEY } from '@/constants';
import { abilityService } from 'beans-admin-plugin';
import _ from 'lodash';
import Utils from '../components/utils.vue';
import { displayText } from '@/custom_models_extend';

@Component
export default class Users extends Mixins(Vue, Utils) {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {};
  allRoles = [];
  currentRole = {};

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    const array = [
      'email_cont',
      'screen_name_cont',
      abilityService.can('roles.read_options') && 'role_id_eq',
      {
        prop: 'team_id_eq',
        label: '团队/小组',
        renderCell: {
          component: 'app-team-tree-select',
        }
      },
    ].filter(Boolean);

    return filterColumnsExtend(array);
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'email',
      'screen_name',
      'phone',
      'role',
      type === 'show' && 'customer_sources',
      'customer_capacity_limit',
      'is_block',
      'related_users',
      { key: 'created_at', sortable: true },
      type === 'show' && 'updated_at',
    ].filter(Boolean);

    return columnsExtend(array);
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    let displayColumns = [
      'email_placeholder',
      'email',
      type === 'new' && 'password_placeholder',
      type === 'new' && 'password',
      'screen_name',
      'phone',
      'customer_capacity_limit'
    ].filter(Boolean);

    if (this.roleKind === 'application') {
      displayColumns = displayColumns.concat(
        [
          'role_id',
          (this.currentRole.kind === 'channel_business_executive' ||
            this.currentRole.kind === 'business_executive') &&
            'customer_source_ids',
          this.currentRole.kind === 'salesman' && 'related_user_ids',
          this.currentRole.kind === 'customer_service' && 'related_user_ids',
          'customer_capacity_limit',
        ].filter(Boolean)
      );
    } else if (this.roleKind === 'business_executive') {
      displayColumns = displayColumns.concat(['role_id', 'customer_capacity_limit']);
    }

    const array = [
      // 防止chrome自动填充账号密码
      {
        prop: 'email_placeholder',
        label: 'email',
        renderCell: (h) => <input h={h} />,
      },
      {
        prop: 'password_placeholder',
        label: 'password',
        renderCell: (h) => <input type="password" h={h} />,
      },
      'email',
      {
        prop: 'password',
        label: '密码',
        renderCell: {
          component: 'input',
          required: true,
          props: {
            showPassword: true,
          },
        },
      },
      'screen_name',
      'phone',
      this.roleKind === 'business_executive'
        ? {
            prop: 'role_id',
            label: '角色',
            renderCell: {
              component: 'select',
              required: true,
              props: {
                clearable: true,
                options: _.map(
                  this.allRoles.filter((item) =>
                    ['salesman', 'customer_service'].includes(item.kind)
                  ),
                  (item) => ({ label: item.name, value: item.id })
                ),
              },
            },
          }
        : {
            prop: 'role_id',
            label: '角色',
            renderCell: {
              component: 'select',
              props: {
                clearable: true,
                xRemotePreload: async () => {
                  return this.allRoles.map((item) => {
                    return { value: item.id, label: item.name };
                  });
                },
              },
              on: {
                change: (value) => {
                  if (value && value !== data.role_id) {
                    this.currentRole = this.allRoles.find(
                      (item) => item.id === value
                    );
                  }
                },
              },
            },
          },
      {
        key: 'customer_source_ids',
        renderCell: {
          required: this.currentRole.kind === 'channel_business_executive',
        },
      },
      {
        key: 'related_user_ids',
        renderCell: {
          props: {
            clearable: true,
            multiple: true,
            xRemotePreload: async () => {
              return (
                await this.$request.get('users/read_options', {
                  per_page: 100,
                  role_kind_in: ['salesman', 'customer_service'],
                  id_not_in: [this.currentUser.id, data.id],
                })
              ).data.map((item) => ({
                value: item.id,
                label: displayText(item),
              }));
            },
            xRemoteSearch: async (keyword) => {
              return (
                await this.$request.get('users/read_options', {
                  keyword,
                  role_kind_in: ['salesman', 'customer_service'],
                  id_not_in: [this.currentUser.id, data.id],
                })
              ).data.map((item) => ({
                value: item.id,
                label: displayText(item),
              }));
            },
          },
        },
      },
      'customer_capacity_limit',
    ].filter(Boolean);

    return formColumnsExtend(array, { data: data, type: type }).filter((item) =>
      displayColumns.includes(item.prop)
    );
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */

  actions({ row }, { remove, reload }) {
    const isCurrentUser = this.currentUser.id === row.id;

    return [
      !isCurrentUser && {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'users.edit', params: { id: row.id } },
        },
      },
      !isCurrentUser &&
        row.is_block && {
          component: 'confirmButton',
          props: {
            label: this.$t('actions.user.isBlockToFalse'),
            can: 'users.update',
            type: 'primary',
          },
          on: {
            confirm: async () => {
              await this.$autoLoading(
                this.$request.put(`/users/${row.id}/unblock`)
              );
              this.$message.success(this.$t('operateSuccess'));
              reload();
            },
          },
        },
      !isCurrentUser &&
        !row.is_block && {
          component: 'confirmButton',
          props: {
            label: this.$t('actions.user.isBlockToTrue'),
            can: 'users.update',
            ype: 'primary',
          },
          on: {
            confirm: async () => {
              await this.$autoLoading(
                this.$request.put(`/users/${row.id}/block`)
              );
              this.$message.success(this.$t('operateSuccess'));
              reload();
            },
          },
        },
      {
        component: 'confirmButton',
        props: {
          label: '模拟登陆',
          can: 'users.mock_login',
          type: 'primary',
        },
        on: {
          confirm: async () => {
            const { user, token } = await this.$autoLoading(
              this.$request.post(`/users/${row.id}/mock_login`)
            );
            localStorage.setItem(TOKEN_STORAGE_KEY, token);
            localStorage.setItem(
              'currentRoleId',
              _.get(user.current_role, 'id')
            );

            this.$message.success('模拟登陆成功');
            location.replace(this.$router.resolve({ name: 'home' }).href);
          },
        },
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'users.destroy',
        },
        on: {
          confirm: () => remove(row.id),
        },
      },
    ].filter(Boolean);
  }

  async onFetchData({ type }) {
    if (type === 'new' || type === 'edit') {
      this.allRoles = await this.$request.get('roles/read_options', {
        page: 0,
      });
    }

    if (type === 'index') {
      const { data, pagination } = await this.$request.get('/users', {
        params: { ...this.$route.query },
      });
      return {
        data,
        pagination,
      };
    }

    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get(`/users/${this.$route.params.id}`);
      this.currentRole = data.role;
      return { data };
    }

    if (type === 'new') {
      return {};
    }
  }
}

export const route = [
  {
    path: '/users',
    name: 'users.index',
    component: Users,
    props: {
      type: 'index',
    },
  },
  {
    path: '/users/new',
    name: 'users.new',
    component: Users,
    props: {
      type: 'new',
    },
  },
  {
    path: '/users/:id',
    name: 'users.show',
    component: Users,
    props: {
      type: 'show',
    },
  },
  {
    path: '/users/:id/edit',
    name: 'users.edit',
    component: Users,
    props: {
      type: 'edit',
    },
  },
];
</script>

<style lang="scss" scoped>
/deep/ .email_placeholder,
/deep/ .password_placeholder {
  position: fixed;
  top: -200%;
  left: -200%;
}
</style>
